import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MainView from '../../../../components/MainView';
import NavHistory from '../../../../components/NavHistory';
import accessServices from '../../../../services/accessServices';
import FormAccess from '../FormAccess';

import './styles.css';



export default function NewAccessPage(props) {

    async function createAccess(accessInfo) {
        try {
            if(accessInfo.nome && accessInfo.tipo !== "" && accessInfo.email && accessInfo.password && accessInfo.telefone && accessInfo.ddi && accessInfo.iso2_ddi){
                await accessServices.postAccess(accessInfo.nome, accessInfo.telefone, accessInfo.ddi, accessInfo.iso2_ddi, accessInfo.email, accessInfo.password,accessInfo.foto);
                props.history.goBack();
            }
            else {
                alert("Todos os campos com asterisco devem ser preenchidos.");
            }

        } catch(err) {
            console.log(err.message);
            alert("Não foi possível criar o acesso. Verifique se todas as informações estão corretas.");
        }
    }

    return (
        <MainView
            adminMenu
            currentPage='accesses'
        >
            <NavHistory
            navPages={['Acessos', 'Novo Acesso']}
            />
            <FormAccess
            title="Cadastro de acesso"
            buttonTitle="Cadastrar acesso"
            onClick={createAccess}
            />
        </MainView>
    )
}